import type { ComponentPropsWithoutRef, FC, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

export interface LabelProps
  extends PropsWithChildren<ComponentPropsWithoutRef<"label">> {
  containerClassName?: string;
}

export const Label: FC<LabelProps> = ({
  containerClassName,
  className,
  children,
  ...props
}) => (
  <div className={twMerge("flex", containerClassName)}>
    <label
      {...props}
      className={twMerge(
        "mr-3 text-base leading-6 text-neutral-50 dark:text-tertiary",
        className,
      )}
    >
      {children}
    </label>
  </div>
);
